import React, { FC, useContext, useState } from 'react';
import { Form } from 'semantic-ui-react';

import { SemanticUIColor } from '@src/types';
import { BasicDialog } from '@src/views/components/modals/BasicDialog';
import { BasicDialogContainer } from '@src/views/components/modals/BasicDialogContainer';
import { useCentralCalls } from '@src/rest/CentralCalls';
import { ProjectContext } from '../ProjectIndexPage';
interface Props {
    onConfirm: (versionName: string) => Promise<void>;
    onClose: () => void;
    projectVersionId: string;
}

const RollUpVersionsDialog: FC<Props> = ({ onConfirm, onClose, projectVersionId }) => {

    const [ versionName, setVersionName ]   = useState( '' ),
          [ isSubmitting, setIsSubmitting ] = useState( false );
    const { executeStoredProcedure } = useCentralCalls();
    const projectContext = useContext(ProjectContext);
    const trimmedName = versionName.trim();
    console.log(projectVersionId);
    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await onConfirm(trimmedName);
            console.log('Creating roll up', { projectVesionId: projectVersionId, ProjectVersionName: trimmedName });
            try {
                await executeStoredProcedure('proc_CreateRollupObjectiveProjectVersion', { ProjectVersionId: projectVersionId, ProjectVersionName: trimmedName });
            }
            catch (err) {
                console.error('Error occurred:', err);
            }
            console.log('rollup version created!')
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <BasicDialog
            onSubmit={handleSubmit}
            onComplete={onClose}
            onClose={onClose}
            className={'no-padding'}
            submitLabel={'Run Roll Up'}
            cancelLabel={'Cancel'}
            operationDisabled={!trimmedName || isSubmitting}
            loading={isSubmitting}
            successToastLabel={'Roll Up completed successfully'}
            errorToastLabel={'Roll Up failed'}
        >
            <BasicDialogContainer title={'Roll Up Versions'} titleColor={SemanticUIColor.PURPLE} onClose={onClose}>
                <p>
                    This operation will create a rolled-up version of the current project version.
                    <strong> Are you sure you want to continue?</strong>
                </p>
                <Form>
                    <Form.Field required>
                        <label>New Version Name</label>
                        <Form.Input
                            placeholder="Enter a name for the new rolled-up version"
                            value={versionName}
                            onChange={(_, { value }) => setVersionName(value)}
                            disabled={isSubmitting}
                        />
                    </Form.Field>
                </Form>
            </BasicDialogContainer>
        </BasicDialog>
    );
};

export { RollUpVersionsDialog };
